import { render } from "./AppContent.vue?vue&type=template&id=526e3f18&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"

import "./AppContent.vue?vue&type=style&index=0&id=526e3f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526e3f18"]])

export default __exports__